<div class="tag" [ngClass]="design">
    <app-icons *ngIf="icon && icon !== ''" [design]="icon"></app-icons>
    <ng-content></ng-content>
</div>